var map = {
	"./404-not-found.jpg": 564,
	"./Affiliate-Banner-Mobile.jpg": 1271,
	"./Affiliate-Banner-desktop.jpg": 1272,
	"./Bank.svg": 730,
	"./Deposit-new-icon.svg": 1273,
	"./Deposit_Now_Icon.svg": 347,
	"./GiftCard/GiftImg.png": 722,
	"./GiftCard/bro.png": 723,
	"./GiftCard/superGiftImg.webp": 803,
	"./Hamburger.svg": 1274,
	"./Promotion/Promotion-Image.jpeg": 1275,
	"./Racebook.svg": 804,
	"./Roketlogo.png": 805,
	"./advance.png": 806,
	"./advance.svg": 807,
	"./affiliate/247-Customer-Support.png": 731,
	"./affiliate/Easy-Accessible-Efficient.png": 732,
	"./affiliate/Hefty-Commissions-94x94.png": 733,
	"./affiliate/Multi-Tier-System.png": 734,
	"./affiliate/Offerings.png": 735,
	"./affiliate/affiliate-banner-900x750.jpg": 1276,
	"./affiliate/stay-up-to-date-94x94.png": 736,
	"./android.png": 808,
	"./appstore.png": 809,
	"./astropay.png": 810,
	"./bank.png": 811,
	"./betfair-logo.png": 737,
	"./bkash.png": 812,
	"./casino-cards.png": 813,
	"./casino-modal.png": 713,
	"./casino.png": 814,
	"./coins.jpg": 1277,
	"./copy.svg": 714,
	"./crash_games/aviat.png": 738,
	"./crash_games/crash_bonus.png": 739,
	"./crash_games/football_manager.png": 740,
	"./crash_games/go_rush.png": 741,
	"./crash_games/keno.png": 742,
	"./crash_games/limbo.png": 743,
	"./crash_games/mines.png": 744,
	"./crash_games/mines_gold.png": 745,
	"./crash_games/plinko.png": 746,
	"./crash_games/tower.png": 747,
	"./crash_games/wheel.png": 748,
	"./credit-card.png": 815,
	"./credit-card.svg": 749,
	"./crypto.png": 816,
	"./depositPageIcons/bhim-logo.jpg": 1278,
	"./depositPageIcons/bhim.png": 817,
	"./depositPageIcons/bhim_logo.jpg": 1279,
	"./depositPageIcons/card_waves.png": 818,
	"./depositPageIcons/google-pay-logo.jpg": 1280,
	"./depositPageIcons/google-pay.png": 819,
	"./depositPageIcons/google_pay_logo.jpg": 1281,
	"./depositPageIcons/pay-tm-logo.jpg": 1282,
	"./depositPageIcons/pay_tm_logo.jpg": 1283,
	"./depositPageIcons/paytm.png": 820,
	"./depositPageIcons/phonepe-logo.jpg": 1284,
	"./depositPageIcons/phonepe.png": 821,
	"./depositPageIcons/phonepe_logo.jpg": 1285,
	"./depositPageIcons/upi-logo.jpg": 1286,
	"./depositPageIcons/upi_logo.jpg": 1287,
	"./depositPageIcons/upi_logo.png": 724,
	"./diamond-logo.png": 822,
	"./download-apk-md.png": 750,
	"./download-apk-mobile.png": 751,
	"./download-apk-pc.png": 752,
	"./downloadapp/Download-app-Image.jpg": 1288,
	"./downloadapp/Download-app-Images.jpg": 1289,
	"./drawer/Affiliate-white.svg": 568,
	"./drawer/about-us.png": 451,
	"./drawer/about-us.svg": 569,
	"./drawer/affiliate.png": 452,
	"./drawer/affiliate.webp": 570,
	"./drawer/arrow-down.png": 453,
	"./drawer/bet_pnl.png": 454,
	"./drawer/blogs.png": 455,
	"./drawer/change_no.png": 456,
	"./drawer/faqs.png": 457,
	"./drawer/faqs.svg": 571,
	"./drawer/favorites.png": 458,
	"./drawer/feedback.png": 286,
	"./drawer/help.svg": 572,
	"./drawer/loyalty.png": 459,
	"./drawer/loyalty.svg": 573,
	"./drawer/market.png": 460,
	"./drawer/market.svg": 574,
	"./drawer/news.png": 461,
	"./drawer/news.svg": 575,
	"./drawer/notification.png": 462,
	"./drawer/online-betting-app.svg": 576,
	"./drawer/open_bets.png": 463,
	"./drawer/privacy.png": 464,
	"./drawer/privacy.svg": 577,
	"./drawer/profile.png": 465,
	"./drawer/promotions.png": 466,
	"./drawer/promotions.svg": 578,
	"./drawer/reset_password.png": 467,
	"./drawer/rules.png": 468,
	"./drawer/settings.png": 469,
	"./drawer/terms-and-conditions.png": 470,
	"./drawer/terms-and-conditions.svg": 579,
	"./drawer/transactions.png": 471,
	"./drawer/wallet.png": 472,
	"./drop.png": 716,
	"./fairplay-book-Logo.png": 823,
	"./fairplay-book-desktop.jpg": 753,
	"./fairplay-book-mobile.jpg": 754,
	"./fairplay-logo.png": 493,
	"./fav_star.svg": 1290,
	"./features/account_box.png": 824,
	"./features/betting-app-left-banner.png": 825,
	"./features/betting_box.png": 826,
	"./features/feature01.png": 827,
	"./features/feature02.png": 828,
	"./features/feature02_old.png": 829,
	"./features/feature03.png": 830,
	"./features/feature04-old.png": 831,
	"./features/feature04.png": 832,
	"./features/feature1-new.png": 755,
	"./features/feature2-new.png": 833,
	"./features/feature3-new.png": 834,
	"./features/feature4-new.png": 835,
	"./features/how-to-register.png": 756,
	"./features/leftside-banner-new.jpg": 836,
	"./features/leftside-banner.jpg": 1291,
	"./features/offers_box.png": 837,
	"./features/otp_page.png": 757,
	"./features/security_box.png": 838,
	"./features/wallet_box.png": 839,
	"./finsa-banner.png": 758,
	"./game-providers/bcoongo.png": 759,
	"./game-providers/bet-games.png": 760,
	"./game-providers/bet-soft.png": 761,
	"./game-providers/evolution-gaming.png": 762,
	"./game-providers/ezugi.svg": 840,
	"./game-providers/ibetsoft.png": 763,
	"./game-providers/microgaming.png": 764,
	"./game-providers/pgsoft.png": 765,
	"./game-providers/realtime-gaming.png": 766,
	"./game-providers/sa-gaming.png": 767,
	"./game-providers/sportsradar1.png": 768,
	"./game-providers/super-spades.png": 769,
	"./game-providers/vivo.jpeg": 841,
	"./game-providers/vivo.png": 770,
	"./game-providers/xpg1.png": 771,
	"./games/32-cards.jpg": 842,
	"./games/7up7down.jpg": 843,
	"./games/AAA-new.png": 844,
	"./games/Andar-Bahar-new.png": 845,
	"./games/Baccarat-new.png": 846,
	"./games/Black-Jack-new.png": 847,
	"./games/Cricket-new.png": 848,
	"./games/Dragon-Tiger-new.png": 849,
	"./games/Dream-Catcher-new.png": 850,
	"./games/Football-new.png": 851,
	"./games/Poker-new.png": 852,
	"./games/Speed-Roulette-new.png": 853,
	"./games/Teen-Patti-Live-new.png": 854,
	"./games/Tennis-new.png": 855,
	"./games/aaa.jpg": 856,
	"./games/andar_bahar.jpg": 857,
	"./games/baccarat.jpg": 858,
	"./games/blackjack.jpg": 859,
	"./games/bollywood_casino.jpg": 860,
	"./games/cricket.jpg": 861,
	"./games/dragon_tiger.jpg": 862,
	"./games/dream_catcher.jpg": 863,
	"./games/football.jpg": 864,
	"./games/pokeer_6players.jpg": 865,
	"./games/poker.jpg": 866,
	"./games/race-20-20.jpg": 867,
	"./games/speed_roulette.jpg": 868,
	"./games/teen-patti_T20.jpg": 869,
	"./games/teen-patti_one-day.jpg": 870,
	"./games/tennis.jpg": 871,
	"./games/worli-matka.jpg": 872,
	"./google-icon.svg": 718,
	"./green-circle-tick.png": 772,
	"./icon_192x192.png": 873,
	"./icon_512x512.png": 874,
	"./illustrations/illustration01.png": 875,
	"./illustrations/illustration02.svg": 1292,
	"./illustrations/illustrationold02.png": 876,
	"./index/live-cards-banner.gif": 877,
	"./index/live-cards-banner2.gif": 773,
	"./index/live-cards-mob.gif": 774,
	"./index/live-casino-banner-mobile.gif": 1293,
	"./index/live-casino-banner.gif": 878,
	"./index/live-casino-banner2.gif": 775,
	"./index/live-casino-mob.gif": 776,
	"./index/premium-new.gif": 1294,
	"./index/premium.gif": 777,
	"./index/premium_old.gif": 1295,
	"./info.svg": 250,
	"./inplayico.png": 778,
	"./inplayico.webp": 1296,
	"./landingpage/Pattern-Background.jpg": 1297,
	"./landingpage/Pattern-mob-Background.jpg": 1298,
	"./landingpage/Pattern.png": 879,
	"./learn-icon.png": 880,
	"./light-pattern.jpg": 658,
	"./line-line.svg": 655,
	"./live-games/2-card-teenpatti.png": 779,
	"./live-games/2-card-teenpatti.webp": 881,
	"./live-games/32-card-casino.png": 780,
	"./live-games/32-card-casino.webp": 882,
	"./live-games/amar-akbar.png": 781,
	"./live-games/amar-akbar.webp": 883,
	"./live-games/andar-bahar.png": 782,
	"./live-games/andar-bahar.webp": 884,
	"./live-games/crazy-time.png": 783,
	"./live-games/crazy-time.webp": 885,
	"./live-games/deal-no-deal.png": 784,
	"./live-games/deal-no-deal.webp": 886,
	"./live-games/dragon-tiger.png": 785,
	"./live-games/dragon-tiger.webp": 887,
	"./live-games/hi-lo.png": 786,
	"./live-games/hi-lo.webp": 888,
	"./live-games/lightning-dice.png": 787,
	"./live-games/lightning-dice.webp": 889,
	"./live-games/money-wheel.png": 788,
	"./live-games/money-wheel.webp": 890,
	"./live-games/roulette.png": 789,
	"./live-games/roulette.webp": 891,
	"./live-games/teenpatti.png": 790,
	"./live-games/teenpatti.webp": 892,
	"./livecards/card-32cardcasino.jpg": 1299,
	"./livecards/card-7updown.jpg": 1300,
	"./livecards/card-aamar-akbar.jpg": 1301,
	"./livecards/card-andarbhar.jpg": 1302,
	"./livecards/card-dragon-tiger.jpg": 1303,
	"./livecards/card-poker.jpg": 1304,
	"./livecards/card-teenpatti.jpg": 1305,
	"./livecards/card-teenpatti20-live.jpg": 1306,
	"./livecards/casino-meter.jpg": 1307,
	"./livecards/cg_6player_poker.jpg": 1308,
	"./livecards/cg_baccarat.jpg": 1309,
	"./livecards/cg_blackjack.jpg": 1310,
	"./livecards/cg_bollywoodcasino.jpg": 1311,
	"./livecards/cg_cricket.jpg": 1312,
	"./livecards/cg_dreamcatcher.jpg": 1313,
	"./livecards/cg_football.jpg": 1314,
	"./livecards/cg_race20_20.jpg": 1315,
	"./livecards/cg_speed_roulette_live.jpg": 1316,
	"./livecards/cg_tennis.jpg": 1317,
	"./livecards/cg_worlimatka.jpg": 1318,
	"./livecards/hi-low.jpg": 1319,
	"./livecards/muflis-teenpatti.jpg": 1320,
	"./loader/loader.gif": 1321,
	"./login-bg.jpg": 791,
	"./logo-lg.png": 893,
	"./logo.png": 894,
	"./logo/betfair-logo.png": 895,
	"./logo/logo-lg.png": 896,
	"./logo/logo.png": 897,
	"./logo/website-logo.png": 491,
	"./loyalty/Crown.png": 475,
	"./loyalty/Loyalty-Plan.jpg": 1322,
	"./loyalty/arrow-black.png": 476,
	"./loyalty/arrow-white.png": 477,
	"./loyalty/blue-bg.png": 478,
	"./loyalty/blue-loyalty-card.png": 479,
	"./loyalty/blue-loyalty.png": 425,
	"./loyalty/card-bg.png": 480,
	"./loyalty/gold-bg.png": 481,
	"./loyalty/gold-loyalty-card.png": 482,
	"./loyalty/gold-loyalty.png": 426,
	"./loyalty/left-blue.jpg": 649,
	"./loyalty/left-blue.png": 231,
	"./loyalty/left-gold.jpg": 651,
	"./loyalty/left-platinum.jpg": 652,
	"./loyalty/left-silver.jpg": 650,
	"./loyalty/only-blue-bg.png": 483,
	"./loyalty/only-gold-bg.png": 484,
	"./loyalty/only-platinum-bg.png": 485,
	"./loyalty/only-silver-bg.png": 486,
	"./loyalty/platinum-bg.png": 487,
	"./loyalty/platinum-loyalty-card.png": 488,
	"./loyalty/platinum-loyalty.png": 427,
	"./loyalty/silver-bg.png": 489,
	"./loyalty/silver-loyalty-card.png": 490,
	"./loyalty/silver-loyalty.png": 428,
	"./menu.png": 898,
	"./menu/Basket-Ball.png": 899,
	"./menu/Cricket.png": 900,
	"./menu/Finance-Trading.png": 901,
	"./menu/Horse-Racing.png": 792,
	"./menu/Inplay.png": 902,
	"./menu/Live-Card.png": 903,
	"./menu/Live-Casino.png": 904,
	"./menu/Premium-Notebook.png": 905,
	"./menu/Slot-Games.png": 906,
	"./menu/Soccer.png": 907,
	"./menu/Sportsbook.png": 908,
	"./menu/Tennis.png": 909,
	"./menu/cardicon.png": 910,
	"./menu/sportsbook/american_football.png": 494,
	"./menu/sportsbook/badminton.png": 495,
	"./menu/sportsbook/baseball.png": 496,
	"./menu/sportsbook/basketball.png": 497,
	"./menu/sportsbook/bowls.png": 498,
	"./menu/sportsbook/boxing.png": 499,
	"./menu/sportsbook/counter_strike.png": 500,
	"./menu/sportsbook/cricket.png": 501,
	"./menu/sportsbook/cycling.png": 502,
	"./menu/sportsbook/darts.png": 503,
	"./menu/sportsbook/dota_2.png": 504,
	"./menu/sportsbook/e_cricket.png": 505,
	"./menu/sportsbook/e_fighting.png": 506,
	"./menu/sportsbook/fifa.png": 507,
	"./menu/sportsbook/fifa_volta.png": 508,
	"./menu/sportsbook/formula1.png": 509,
	"./menu/sportsbook/golf.png": 510,
	"./menu/sportsbook/handball.png": 511,
	"./menu/sportsbook/ice_hokey.png": 512,
	"./menu/sportsbook/motorcycle_racing.png": 513,
	"./menu/sportsbook/nba2k19.png": 514,
	"./menu/sportsbook/rugby.png": 515,
	"./menu/sportsbook/snooker.png": 516,
	"./menu/sportsbook/soccer.png": 517,
	"./menu/sportsbook/tabletennis.png": 518,
	"./menu/sportsbook/tennis.png": 519,
	"./menu/sportsbook/volleyball.png": 520,
	"./menu/sportsbook/waterpolo.png": 521,
	"./nagad.png": 911,
	"./premium-bg.svg": 1323,
	"./premium-sport-logo.png": 912,
	"./profile.svg": 654,
	"./promo_code.svg": 793,
	"./promotion-banner-desktop.jpg": 1324,
	"./promotion-banner-mobile.jpg": 1325,
	"./purse.png": 287,
	"./referandearn.png": 913,
	"./referandearn1.png": 914,
	"./register-whatsapp.png": 282,
	"./slider.jpg": 1326,
	"./sportsbook-categories/badminton.png": 401,
	"./sportsbook-categories/baseball.png": 402,
	"./sportsbook-categories/basketball.png": 403,
	"./sportsbook-categories/binary.png": 431,
	"./sportsbook-categories/boxing.png": 404,
	"./sportsbook-categories/cardicon.png": 405,
	"./sportsbook-categories/casino.png": 406,
	"./sportsbook-categories/crash_games.png": 432,
	"./sportsbook-categories/cricket.png": 433,
	"./sportsbook-categories/cs.png": 407,
	"./sportsbook-categories/dota.png": 408,
	"./sportsbook-categories/efighting.png": 409,
	"./sportsbook-categories/election.png": 434,
	"./sportsbook-categories/fifa.png": 410,
	"./sportsbook-categories/formula.png": 411,
	"./sportsbook-categories/golf.png": 412,
	"./sportsbook-categories/greyhound-racing.png": 435,
	"./sportsbook-categories/greyhound.png": 413,
	"./sportsbook-categories/horse-racing.png": 436,
	"./sportsbook-categories/horse.png": 414,
	"./sportsbook-categories/inplay.png": 437,
	"./sportsbook-categories/kabaddi.jpg": 915,
	"./sportsbook-categories/kabaddi.png": 415,
	"./sportsbook-categories/live-card.png": 438,
	"./sportsbook-categories/live-casino.png": 439,
	"./sportsbook-categories/lottery.png": 440,
	"./sportsbook-categories/more.png": 441,
	"./sportsbook-categories/premium-notebook.png": 442,
	"./sportsbook-categories/raceicon.png": 443,
	"./sportsbook-categories/rugby.png": 416,
	"./sportsbook-categories/slot-games.png": 444,
	"./sportsbook-categories/sloticon.png": 417,
	"./sportsbook-categories/sloticon1.png": 445,
	"./sportsbook-categories/soccer.png": 446,
	"./sportsbook-categories/sportsbook.png": 447,
	"./sportsbook-categories/table-tennis.png": 418,
	"./sportsbook-categories/tennis.png": 448,
	"./sportsbook-categories/virtual.png": 419,
	"./sportsbook-categories/voleyball.png": 420,
	"./survey.svg": 916,
	"./telegram.svg": 1327,
	"./telegramapp.svg": 1328,
	"./thanks-modified.png": 725,
	"./upcomingico.png": 794,
	"./upcomingico.webp": 1329,
	"./upload-sign.svg": 795,
	"./upload.svg": 917,
	"./utr_id_images.svg": 796,
	"./utr_upload.svg": 918,
	"./wallet-bank.png": 919,
	"./wallet-crypto.png": 920,
	"./wallet-payment-methods.png": 921,
	"./wallet-primary.svg": 719,
	"./wallet.svg": 348,
	"./whatsApp.svg": 797,
	"./whatsapp.png": 922,
	"./whatsapp_pay.png": 726,
	"./whatsup-icon1.svg": 1330,
	"./world-logo.png": 923,
	"./wpng.png": 924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1270;